import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { LectureDetails } from '../../../../../api/types/lecturers/details/lecture-details';

export const loadLectureDetailsForAttendanceOperation = async (
  programId: number,
  courseId: number,
  lectureId: number,
  setLoading: (loading: boolean) => void,
): Promise<LectureDetails | null> => {
  try {
    setLoading(true);
    const res = await appApi.getLectureDetails(programId, courseId, lectureId);
    return res.data.body ?? null;
  } catch (e) {
    console.error(
      `loadLectureDetailsForAttendanceOperation failed for programId: ${programId}, courseId: ${courseId}, lectureId: ${lectureId}`,
      e,
    );
    toast.error('משהו קרה, לא ניתן לטעון את פרטי המפגש...');
    return null;
  } finally {
    setLoading(false);
  }
};
